<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const plates = [
  {
    img: new URL("../assets/img/plate1.png", import.meta.url).href,
    title: "Choice of Wings",
    desc: "Rice n Peas · Mac n Cheese · Veggie · Sweet Potato · Biscuit"
  },
  {
    img: new URL("../assets/img/plate2.png", import.meta.url).href,
    title: "Rack of Lamb (3)",
    desc: "Rice n Peas · Mac n Cheese · Veggie · Sweet Potato · Biscuit"
  },
  {
    img: new URL("../assets/img/plate3.png", import.meta.url).href,
    title: "Grilled Tiger Shrimp (4)",
    desc: "Rice n Peas · Mac n Cheese · Veggie · Sweet Potato · Biscuit"
  }
];

const currentIndex = ref(0);
let timeout1 = null;
let timeout2 = null;

onMounted(() => {
  // 🔥 preload images
  plates.forEach(p => {
    const img = new Image();
    img.src = p.img;
  });

  const loop = () => {
    timeout1 = setTimeout(() => {
      currentIndex.value =
        (currentIndex.value + 1) % plates.length;

      timeout2 = setTimeout(loop, 3000);
    }, 3000);
  };

  loop();
});

onUnmounted(() => {
  clearTimeout(timeout1);
  clearTimeout(timeout2);
});
</script>

<template>
  <NavBar />

  <section class="hungrys">
    <!-- LOGO (moves on mobile) -->
    <div class="mobile-logo">
      <img
        src="../assets/img/hungrys_logo_1.svg"
        alt="HUNGRYS"
      />
    </div>

    <!-- PLATE -->
    <div class="plate-wrap">
      <img
        v-for="(plate, i) in plates"
        :key="i"
        :src="plate.img"
        class="hungrys-plate"
        :class="{ active: i === currentIndex }"
      />

      <div class="menu-sticker">
        <span class="sticker-tag">Hungry’s Pick</span>
        <p class="sticker-title">
          {{ plates[currentIndex].title }}
        </p>
        <p class="sticker-desc">
          {{ plates[currentIndex].desc }}
        </p>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="content">
      <!-- DESKTOP LOGO -->
      <img
        src="../assets/img/hungrys_logo_1.svg"
        alt="HUNGRYS"
        class="logo desktop-only"
      />

      <!-- BUTTONS -->
      <div class="buttons-container">
        <a
          href="https://www.ubereats.com/ca/store/hungrys/EkSfxRRvT2OHO4oBAQnbbw"
          class="logo-button"
          target="_blank"
        >
          <img src="../assets/img/ubereats.png" alt="Uber Eats" />
        </a>

        <a
          href="https://www.doordash.com/store/hungrys-montr%C3%A9al-24974949/"
          class="logo-button"
          target="_blank"
        >
          <img src="../assets/img/doordash.png" alt="DoorDash" />
        </a>
      </div>
    </div>
  </section>
</template>

<style>

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Montserrat", sans-serif;
    font-family: 'League Gothic', sans-serif;
}

/* LAYOUT */
.hungrys {
  min-height: calc(100vh - 5rem);
  margin-top: 7rem;

  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  justify-items: center;

  gap: clamp(1rem, 4vw, 4rem);
  padding: clamp(1rem, 4vw, 4rem);
}

/* LOGOS */
.mobile-logo {
  display: none;
}

.mobile-logo img {
  width: 18rem;
}

.desktop-only {
  display: block;
}

/* PLATE */
.plate-wrap {
  position: relative;
  width: clamp(18rem, 40vw, 50rem);
  height: clamp(14rem, 28vw, 32rem);
}

.hungrys-plate {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: contain;

  opacity: 0;
  transition: opacity 400ms ease;
}

.hungrys-plate.active {
  opacity: 1;
}

/* STICKER */
.menu-sticker {
  position: absolute;
  bottom: -1rem;
  right: -1rem;

  width: min(18rem, 80vw);
  padding: 0.5rem 1rem;
font-family: 'league gothic', sans-serif;
  background: #fff7ec;
  border-radius: 14px;

  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.25);
  transform: rotate(-2deg);
}

.sticker-tag {
  font-size: 0.8rem;
  text-transform: uppercase;
  opacity: 0.6;
}

.sticker-title {
  font-size: 1.4rem;
  font-weight: 400;
}

.sticker-desc {
  font-size: 0.85rem;
  opacity: 0.7;
}
/* CONTENT */
.content {
  max-width: 38rem;
  text-align: center;
}

.logo {
  width: min(34rem, 90vw);
  margin-bottom: 2rem;
}

/* BUTTONS */
.buttons-container {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.logo-button {
  padding: 12px 18px;
  border-radius: 999px;

  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);

  transition: transform 200ms ease;
}

.logo-button img {
  height: 72px;
  border-radius: 1rem;
}

.logo-button:hover {
  transform: translateY(-2px);
}

/* 📱 MOBILE + TABLET */
@media (max-width: 1024px) {
  .hungrys {
    grid-template-columns: 1fr;


    grid-template-areas:
      "logo"
      "plate"
      "content";
  }

  .mobile-logo {
    display: block;
    grid-area: logo;
    text-align: center;
  }

  .plate-wrap {
    grid-area: plate;
    width: 100%;
    height: 30vh;
  }

  .content {
    grid-area: content;
  }

  /* hide desktop logo */
  .desktop-only {
    display: none;
  }

  /* buttons full width (nice touch) */
  .buttons-container {
    flex-direction: column;
    align-items: center;
  }

 
}
</style>